export default "__VITE_ASSET__CAgWoi$e__"